(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trDashboardLayout', trDashboardLayout);

  function trDashboardLayout() {
    const directive = {
      restrict: 'E',
      scope: {},
      controller: 'DashboardLayoutController',
      controllerAs: 'vm',
      templateUrl: '/scripts/components/dashboard/dashboard-layout.view.html',
    };
    return directive;
  }
})();
